<template>
    <div class="database" :class="{'databaseDark': isDark}">
        <div class="nav">
            <span>基本信息</span>
        </div>
        <div class="basicInfo" v-if="teamInfo">
            <div class="box">
                <div class="item">
                    <span>加入年份：</span><span>{{teamInfo.join_year}}</span>
                </div>
                <div class="item">
                    <span>球队场馆：</span><span>{{teamInfo.gymnasium}}</span>
                </div>
            </div>
            <div class="box">
                <div class="item">
                    <span>所在城市：</span><span>{{teamInfo.area}}</span>
                </div>
                <div class="item">
                    <span>容纳人数：</span><span>{{teamInfo.capacity}}</span>
                </div>
            </div>
        </div>
        <template v-if="transfer">
            <div class="nav">
                <span>转会记录</span>
                <span class="picker" @click="show = true">
                    {{season}}
                    <van-icon name="arrow-down" />
                </span>
            </div>
            <div class="transferRecord">
                <div class="item" v-for="(item, index) in transfer[season]" :key="index">
                    <div class="time">
                        {{item.transfer_time.replace(/-/g, '.')}}
                    </div>
                    <div class="match">
                        <div class="team home">
                            <span>{{item.team_name}}</span>
                            <img :src="item.team_name_logo" alt="">
                        </div>
                        <div class="replacement">
                            <!-- {{item.type}} -->
                        </div>
                        <div class="team away" @click="goTeam(item.now_team_id)">
                            <img :src="item.now_team_name_logo" alt="">
                            <span>{{item.now_team_name}}</span>
                        </div>
                    </div>
                    <div class="name">
                        {{item.player_name}}
                    </div>
                </div>
            </div>
        </template>
        <template v-if="honor && honor.length > 0">
            <div class="nav">
                <span>球队荣誉</span>
            </div>
            <div class="teamHonors" v-for="(item, index) in honor" :key="index">
                <div class="title">
                    {{item.honor}}：{{item.num}}次
                </div>
                <div class="itemBox">
                    <div class="item" v-for="(is, ink) in item.season" :key="ink">
                        <span>
                            <img :src="item.logo" alt="">
                        </span>
                        <span>{{is}}</span>
                    </div>
                </div>
            </div>
        </template>
        <van-popup
            v-model="show"
            round
            position="bottom"
            :style="{ height: '40vh' }"
        >
            <van-picker
                show-toolbar
                :columns="seasonArr"
                :default-index="0"
                @confirm="onConfirm"
                @cancel="show = false"
            />
        </van-popup>
    </div>
</template>

<script>
import { getLQTeamInfoBase } from "@/api/team.js"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "database",
    data () {
        return {
            show: false,
            columns: ['2001', '2002'],
            team_id: this.$route.query.team_id,
            transfer: null,
            honor: null,
            seasonArr: [],
            season: ''
        };
    },
    computed: {
        teamInfo () {
            return this.$store.state.team.teamInfo
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.getLQTeamInfoBase()
        // window.scrollTo({
        //     top: 0,
        //     behavior: "instant"
        // })
    },
    methods: {
        goTeam (id) {
            jsbridg.goWebview({
                url: process.env.VUE_APP_DOMAIN + `/team/database?team_id=${id}&top_bar_style=2`,
                jumptype: 2
            });
        },
        // 转会记录
        async getLQTeamInfoBase () {
            const params = {
                team_id: this.team_id || 1
            }
            const res = await getLQTeamInfoBase(params)
            if (res.errno === 0) {
                if (res.data) {
                    const obj = {}
                    res.data.transfer.forEach((item) => {
                        if (obj[item.season]) {
                            obj[item.season].push(item)
                        } else {
                            obj[item.season] = [item]
                        }
                    });
                    const arr = Array.from(new Set(res.data.transfer.map(item => item.season)))
                    arr.sort((a, b) => {
                        if (a && b) {
                            return parseInt(a.split('-')[0] + a.split('-')[1]) + parseInt(b.split('-')[0] + b.split('-')[1])
                        }
                    })
                    this.seasonArr = arr
                    this.season = this.seasonArr[0]
                    this.transfer = obj
                    this.honor = res.data.honor
                }
            } else {
                this.$toast(res.errmsg)
            }
        },
        onConfirm (value) {
            this.season = value
            this.show = false
        }
    }
}
</script>

<style lang="less" scoped>
.database{
    padding: 0 14px;
    .nav{
        height: 43px;
        padding-top: 8px;
        font-size: 13px;
        font-weight: 500;
        color: #333333;
        display: flex;
        align-items: center;
        &::before{
            content: '';
            width: 3px;
            height: 14px;
            background: #169AFF;
            margin-right: 5px;
        }
        position: relative;
        .picker{
            position: absolute;
            right: 0;
        }
    }
    .basicInfo{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        height: 69px;
        background: #FFFFFF;
        box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.15);
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        .box{
            .item{
                display: flex;
                align-items: center;
                span{
                    &:first-child{
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                    }
                    &:last-child{
                        font-size: 12px;
                        font-weight: 400;
                        color: #333;
                    }
                }
                &:first-child{
                    margin-bottom: 10px;
                }
            }
        }
    }
    .transferRecord{
        .item{
            display: flex;
            height: 30px;
            align-items: center;
            justify-content: center;
            .time{
                width: 65px;
            }
            .match{
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                .team{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    span{
                        font-size: 12px;
                        font-weight: 400;
                        color: #333333;
                    }
                    img{
                        width: 20px;
                        height: 20px;
                    }
                }
                .home{
                    justify-content: flex-end;
                    img{
                        margin-left: 5px;
                    }
                }
                .away{
                    justify-content: flex-start;
                    img{
                        margin-right: 5px;
                    }
                }
                .replacement{
                    width: 15px;
                    margin: 0 5px;
                }
            }
            .name{
                width: 60px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .teamHonors{
        .title{
            font-size: 15px;
            font-weight: bold;
            color: #333333;
        }
        .itemBox{
            display: flex;
            align-items: center;
            // justify-content: space-between;
            flex-wrap: wrap;
            .item{
                width: 55px;
                margin-right: 17px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;
                span{
                    &:first-child{
                        img{
                            width: 50px;
                            height: 50px;
                        }
                    }
                    &:last-child{
                        font-size: 10px;
                        font-weight: 400;
                        color: #7D7D7D;
                    }
                }
                &:nth-child(5n) {
                    margin-right: 0;
                }
            }
        }
    }
}
.databaseDark{
    background-color: #191919;
    min-height: calc(100vh - 200px);
    .nav{
        color: #d3d3d3;
    }
    .basicInfo{
        background-color: #191919;
        border-color: #2f2f2f;
        .box{
            .item{
                span{
                    &:first-child{
                        color: #a6a6a6;
                    }
                    &:last-child{
                        color: #d3d3d3
                    }
                }
            }
        }
    }
    .transferRecord{
        .item{
            color: #d3d3d3;
            .match .team span{
                color: #d3d3d3;
            }
        }
    }
    .teamHonors{
        .title{
            color: #d3d3d3;
        }
        .itemBox .item{
            span{
                &:last-child{
                    color: #595959;
                }
            }
        }
    }
}
</style>
